import "./layout";
import { App } from "vue";
import { createRouter, createWebHistory, Router } from "vue-router";
import { OnError, OnRequest } from "@/plugins/api";
import { useAuthStore } from "@/store/auth-store";
import { AuthService } from "@/services";
import {
  AdminLayoutRoute,
  AuthLayoutRoute,
  ManagerLayoutRoute,
  UserLayoutRoute,
} from "@/router/layout";

async function findRotes(router: Router) {
  const authStore = useAuthStore();

  OnRequest((response) => {
    if (!authStore.hasToken) return;
    response.headers["Authorization"] = `Bearer ${authStore.getToken}`;
  });

  OnError((error) => {
    if (error.response?.status === 401) {
      authStore.removeSession();
      router.clearRoutes();
      router.addRoute(AuthLayoutRoute);
      router.push({
        name: "SIGN_IN_PAGE",
      });
    }
  });

  router.afterEach((to, _from, failuer) => {
    if (failuer) {
      return;
    }
    document.title = to.meta.title || APP_TITLE;
  });

  router.beforeEach(async (to, _from, next) => {
    const routes = router.getRoutes();

    const route = routes.find((route) => route.name === to.name);

    if (!route) {
      const layout = routes.find((route) => route.meta.isLayout);

      const child = layout!.children.find((route) => route)!;

      return next({ name: child.name });
    }

    return next();
  });

  router.clearRoutes();

  if (!authStore.hasToken) {
    router.addRoute(AuthLayoutRoute);
    return true;
  }

  try {
    const user = await AuthService.me();
    authStore.setUser(user);

    switch (user.role) {
      case "USER":
        router.addRoute(UserLayoutRoute);
        return true;
      case "ADMIN":
        router.addRoute(AdminLayoutRoute);
        return true;
      case "MANAGER":
        router.addRoute(ManagerLayoutRoute);
        return true;
    }
  } catch (error) {}
}

export async function installRouter(app: App) {
  const router = createRouter({
    history: createWebHistory(),
    routes: [],
  });

  await findRotes(router);

  app.use(router);

  await router.isReady();
}
